import httpClient from "./httpClient";

const prefix = "/application-statuses";

export async function readApplicationStatuses() {
  return (await httpClient.get(`${prefix}`)).data;
}
